import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackShowcaseSubpageHidden.meta';

export type UseTrackShowcaseSubpageHiddenParams = {
  hidden: boolean;
};

export const useTrackShowcaseSubpageHidden = () => {
  const { track } = useAnalyticsUtilities();

  const trackShowcaseSubpageHidden = useCallback(
    (params: UseTrackShowcaseSubpageHiddenParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackShowcaseSubpageHidden };
};
